export default __webpack_public_path__ + "static/media/download.45c6482d.svg";